<template>
	<ModalRouting
		:loading="loading"
		:title="'Rota do motorista ' + current.nickname"
		@close="close"
	>
		<div v-if="loading" class="row">
			<div class="col-xs-12 loading">
				<i class="fa fa-circle-notch fa-spin"></i>
			</div>
		</div>
        <div class="row">
			<div class="col-xs-12">
				<route-google-maps
					:driver="current"
					:deliveries="current_data.deliveries"
					:positions="current_data.positions"
					:settings="settings"
					ref="route"
				>
				</route-google-maps>
			</div>
		</div>
	</ModalRouting>
</template>

<script>
import Api from "@/lib/Api";

import ModalRouting from "@/components/ModalRouting";
import RouteGoogleMaps from '../../components/RouteGoogleMaps.vue';

export default {
	name: "DriverRoute",

	props: {
		current: {
			type: Object,
			require: true,
		},
		settings: {
			type: Object,
			require: true,
		},
	},

	components: {
		ModalRouting,
		RouteGoogleMaps,
	},

	data: function() {
		return {
			loading: true,
			current_data: {},
		}
	},

	created: async function() {
		// Sinaliza o carregamento
		this.loading = true;
		// Requsita todas as informações
		await this.load();
		// Sinaliza o fim do carregamento
		this.loading = false;
	},
	
	methods: {
		/**
		 * Requisita a API os pontos
		 **/
		load: async function() {
			// Inicia o objeto de resultado
			let result = null;
			
			// Obtém as informações da rota
			try {
				result = await Api.post('driver/get-route', {
					id: this.current.id,
					document: this.current.document,
				});
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter a rota.");
				this.close();
				return;
			}
			
			// Verifica se foi retornado algo
			if(result != null) {
				if(result.error) {
					this.$notification.error(result.data);
					this.close();
					return;
				}

				if(result.data.length == 0) {
					this.$notification.error("Nenhuma rota disponível neste momento.");
					this.close();
					return;
				} else {
					// Armazena as informações retornadas
					this.current_data = result.data;
					this.current["current_license_plate"] = result.data.deliveries[0].license_plate;
					this.current["current_cargo"] = result.data.deliveries[0].cargo;

					// Inicia o mapa
					this.$nextTick(() => {
						if (this.$refs.route) {
							this.$refs.route.start();
						}
					});
				}
			} else {
				this.$notification.error("Nenhuma rota encontrada.");
				this.close();
				return;
			}
		},

		/**
		 * Emite o fechamento do modal
		 **/
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.card-map {
	position: absolute;
}

.card {
    height: auto;
    width: 370px;
	margin-top: 10px;
	margin-left: 10px;
    background: #fff;
    z-index: 3;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}

.card-head {
    padding: 10px;
    background-color: #a6a6a6;
	color: rgb(44, 62, 80);
    font-size: 16px;
}

.card-body {
	height: calc(100vh - 190px);
    padding: 10px;
    background-color: #fff;
	overflow-y: auto;
	overflow-x: hidden;
}

.driver-info-body-inner {
	float: left;
	width: 100%;
	border: 1px solid #f5f5f5;
	padding: 0 5px;
	box-sizing: initial;
}

.driver-info-item {
	position: relative;
    padding: 10px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.driver-info-item-head {
	background-color: #cdcdcd;
	color: rgb(44, 62, 80);
	cursor: pointer;
}

.driver-info-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
}

.driver-info-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}

.map {
	z-index: 1;
}

.loading {
    height: calc(100vh - 190px);
    background: #fff;
    font-size: 80px;
	color: #ddd;
    text-align: center;
    line-height: calc(100vh - 190px);
    font-family: Verdana;
    z-index: 10;
}

.control {
	position: absolute;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	padding: 10px;
	background-color: #fff;
	color: #666;
	z-index: 3;
	border-radius: 2px;
	cursor: pointer;
}

.control-start {
	left: calc(100vw - 85px);
	top: calc(100vh - 145px);
}

.control-driver {
	left: calc(100vw - 85px);
	top: calc(100vh - 95px);
}
</style>